import { useTheme, useMediaQuery } from '@mui/material';

/** Viewport téléphone / petite tablette (< 600px). */
export function useIsMobileSm(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

/** Viewport &lt; md (drawer temporary du Layout). */
export function useIsMobileMd(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
